import { render, staticRenderFns } from "./BdoNoAccount.vue?vue&type=template&id=c6610c66&scoped=true"
import script from "./BdoNoAccount.vue?vue&type=script&lang=js"
export * from "./BdoNoAccount.vue?vue&type=script&lang=js"
import style0 from "./BdoNoAccount.vue?vue&type=style&index=0&id=c6610c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6610c66",
  null
  
)

export default component.exports